import ApplicationController from '../../support/application_controller'
import WizardMixin           from '../../support/wizard_mixin'
import mixin                 from '../../support/mixin'

import {
  disableElements,
  enableElements
} from '../../support/helpers'

export default class extends mixin(ApplicationController, WizardMixin) {

  static targets = [
    'autoSave',
    'form',
    'ingredient',
    'ingredientInput',
    'medicationInput',
    'prescription',
    'referralLetter'
  ]

  static classes = [
    'hide'
  ]

  togglePrescription({ currentTarget: { checked }, params: { prescription, noIngredients } }) {
    const prescriptionTarget = this.prescriptionTargets
      .find((target) => target.dataset.prescription === prescription)
    if (!prescriptionTarget) return

    prescriptionTarget.classList.toggle(this.hideClass, !checked)
    disableElements(prescriptionTarget, !checked)

    if (checked) {
      if (noIngredients) {
        this.#autoSelect(prescriptionTarget, this.medicationInputTargets)
      } else {
        this.#autoSelect(prescriptionTarget, this.ingredientInputTargets, (input) => {
          this.toggleIngredient({ currentTarget: input, params: { prescription } })
        })
      }
    }
  }

  toggleIngredient({ currentTarget: { value }, params: { prescription } }) {
    this.ingredientTargets
      .filter((target) => target.dataset.prescription === prescription)
      .forEach((ingredientTarget) => {
        if (ingredientTarget.dataset.ingredient === value) {
          ingredientTarget.classList.remove(this.hideClass)
          enableElements(ingredientTarget)
          this.#autoSelect(ingredientTarget, this.medicationInputTargets)
        } else {
          ingredientTarget.classList.add(this.hideClass)
          disableElements(ingredientTarget)
        }
      })
  }

  toggleReferralLetter(event) {
    if (event.currentTarget.value === 'referral_letter_required') {
      this.showRadioButtonMoreDetails({
        target: this.referralLetterTarget
      })
    } else {
      this.hideRadioButtonMoreDetails({
        target: this.referralLetterTarget
      })
    }
  }

  autoSaveICD10Code(event) {
    event.currentTarget.form.requestSubmit()
  }

  autoSave() {
    if (!this.hasAutoSaveTarget) return

    this.formTarget.requestSubmit(this.autoSaveTarget)
  }

  // ===== Private

  #autoSelect(wrapper, inputTargets, block = () => {}) {
    const inputs = inputTargets.filter((target) => wrapper.contains(target))
    if (inputs.length === 1) {
      const [input] = inputs
      input.checked = true
      block(input)
    }
  }

}
